import React, { Component } from 'react';
import { Label, Segment, Form } from 'semantic-ui-react';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextInput from '../../../app/common/Form/TextInput';
import SelectInput from '../../../app/common/Form/SelectInput';
import { getCardBins } from '../PaymentActions';
import classnames from 'classnames';

const monthOptions = [
  { key: '01', text: '01', value: '01' },
  { key: '02', text: '02', value: '02' },
  { key: '03', text: '03', value: '03' },
  { key: '04', text: '04', value: '04' },
  { key: '05', text: '05', value: '05' },
  { key: '06', text: '06', value: '06' },
  { key: '07', text: '07', value: '07' },
  { key: '08', text: '08', value: '08' },
  { key: '09', text: '09', value: '09' },
  { key: '10', text: '10', value: '10' },
  { key: '11', text: '11', value: '11' },
  { key: '12', text: '12', value: '12' }
];

let yearOptions = [];
const current_year = (new Date()).getFullYear();
const limit_year = current_year + 30;
for (let i = current_year; i <= limit_year; i++) {
  yearOptions.push({
    key: i + 'year',
    text: i.toString(),
    value: i.toString()
  });
}

// const cardType = [
//   { key: 'visa', text: 'Visa', value: 'visa' },
//   { key: 'master', text: 'Master', value: 'master' },
//   { key: 'maestro', text: 'Maestro', value: 'maestro' },
//   { key: 'rupay', text: 'Rupay', value: 'rupay' },
//   { key: 'amex', text: 'Amex', value: 'amex' },
//   { key: 'diners', text: 'Diners', value: 'diners' }
// ];
const mapState = (state) => ({
  cardBins: state.payment.cardBins
});

const actions = dispatch => ({
  getCardBrandBins: () => {
    dispatch(getCardBins());
  },
  resetFieldValue: (form, field) => {
    dispatch(change(form, field, ''));
  }
});

class CreditCardInputBox extends Component {
  static propTypes = {
    cardBins: PropTypes.object,
    getCardBrandBins: PropTypes.func,
    resetFieldValue: PropTypes.func,
  };

  state = {
    maxLen: 3,
    showCVVError: false,
  };

  constructor(props) {
    super(props);
    const { getCardBrandBins, cardBins } = props;
    if (!cardBins) {
      getCardBrandBins();
    }

    this.cvvNumberError = 'Please enter valid CVV';
    this.getCardBrandFromBin = this.getCardBrandFromBin.bind(this);
    this.cardNumberChanged = this.cardNumberChanged.bind(this);
  }

  vendorChanged = (e, value) => {
    this.setState({
      maxLen: (value === 'amex') ? 4 : 3,
    });
  }

  cvvChanged = event => {
    const val = event.target.value;

    if (val !== '' && !/^\d+$/.test(val)) {
      this.setState({ showCVVError: true });
    } else {
      this.setState({ showCVVError: false });
    }
  }

  cardNumberChanged = event => {
    const { resetFieldValue } = this.props;

    const cardBrand = this.getCardBrandFromBin(event.target.value);
    if (cardBrand && cardBrand === 'AMEX' && this.state.maxLen === 3) {
      this.setState({
        maxLen: 4
      });
    }
    else if (cardBrand && cardBrand !== 'AMEX' && this.state.maxLen === 4) {
      this.setState({
        maxLen: 3
      });
      resetFieldValue('addMoneyForm', 'card_cvv');
    }
  }

  getCardBrandFromBin = cardNumberValue => {
    const { cardBins } = this.props;

    const allCardBins = cardBins ? cardBins['allBins'] : [];
    let brandValue = '';

    for (let index = 0; index < allCardBins.length; index++) {
        const cardBinObject = allCardBins[index];
        const extractDigits = cardNumberValue.substring(
            0,
            parseInt(cardBinObject['noOfDigits'], 10)
        );

        if (
            parseInt(extractDigits, 10) >= parseInt(cardBinObject['lowerLimit'], 10) &&
            parseInt(extractDigits, 10) <= parseInt(cardBinObject['upperLimit'], 10)
        ) {
            brandValue = cardBinObject['cardType'];
            break;
        }
    }

    return brandValue;
  }

  render() {
    const { cardBins } = this.props;

    return (
      <React.Fragment>
        {
          cardBins && (
            <Segment>
              <Field
                name="card_num"
                type="tel"
                allowonlynumber="true"
                maxLength={19}
                component={TextInput}
                placeholder="Card number"
                onChange={this.cardNumberChanged}
              />

              <Form.Group widths="equal">
                <Field
                  name="card_exp_month"
                  type="text"
                  options={monthOptions}
                  component={SelectInput}
                  placeholder="Month"
                />
                <Field
                  name="card_exp_year"
                  type="text"
                  options={yearOptions}
                  component={SelectInput}
                  placeholder="Year"
                />
                {/* <Field
                  name="card-vendor"
                  type="text"
                  options={cardType}
                  component={SelectInput}
                  onChange={this.vendorChanged}
                  placeholder="Card Type"
                /> */}
                <Field
                  name="card_cvv"
                  type="tel"
                  maxLength={this.state.maxLen}
                  onChange={this.cvvChanged}
                  allowonlynumber="true"
                  component={TextInput}
                  autoComplete="off"
                  placeholder="CVV"
                  className={classnames(
                    'securityfield',
                    { 'error': this.state.showCVVError }
                  )}  
                />
                {this.state.showCVVError && (
                  <Label className="floatRight" basic color="red">
                    {this.cvvNumberError}
                  </Label>
                )}
              </Form.Group>
            </Segment>
          )
        }        
      </React.Fragment>
    );
  }
}

export default connect(mapState, actions)(CreditCardInputBox);
